var map = {
	"./About/Dynamic.vue": [
		"7f07",
		"chunk-01e39a70",
		"chunk-4c638ff6"
	],
	"./About/DynamicDetail.vue": [
		"d28d",
		"chunk-01e39a70",
		"chunk-30b01f10"
	],
	"./About/index.vue": [
		"d530",
		"chunk-249427a4"
	],
	"./EcoPartner/Cooperate.vue": [
		"f346",
		"chunk-01e39a70",
		"chunk-0a6e336a"
	],
	"./EcoPartner/index.vue": [
		"1059",
		"chunk-01e39a70",
		"chunk-a2eb4a16"
	],
	"./ErrorPages/404.vue": [
		"898f",
		"chunk-2d0df2e5"
	],
	"./Index/index.vue": [
		"fbaf",
		"chunk-01e39a70",
		"chunk-0b2bab70"
	],
	"./Industrial/AgentOperation.vue": [
		"6ed5",
		"chunk-01e39a70",
		"chunk-2c846bda",
		"chunk-6155f859"
	],
	"./Industrial/Finance.vue": [
		"8d61",
		"chunk-01e39a70",
		"chunk-2c846bda",
		"chunk-f7be32c4"
	],
	"./Industrial/Supplychain.vue": [
		"2880",
		"chunk-01e39a70",
		"chunk-2c846bda",
		"chunk-2fefea23"
	],
	"./Information/index.vue": [
		"b4d8",
		"chunk-01e39a70",
		"chunk-51d0cd96"
	],
	"./Solution/B2B2C.vue": [
		"b511",
		"chunk-01e39a70",
		"chunk-2c846bda",
		"chunk-5ff8e429"
	],
	"./Solution/BrandCustom.vue": [
		"d572",
		"chunk-01e39a70",
		"chunk-2c846bda",
		"chunk-29c6949b"
	],
	"./Solution/Cashier.vue": [
		"2e33",
		"chunk-01e39a70",
		"chunk-2c846bda",
		"chunk-9dcf08f0"
	],
	"./Solution/ChainE.vue": [
		"c5bd",
		"chunk-01e39a70",
		"chunk-2c846bda",
		"chunk-824dd170"
	],
	"./Solution/CloudPurchase.vue": [
		"cbe3",
		"chunk-01e39a70",
		"chunk-2c846bda",
		"chunk-32c62a22"
	],
	"./Solution/Community.vue": [
		"4111",
		"chunk-01e39a70",
		"chunk-2c846bda",
		"chunk-9bb25cee"
	],
	"./Solution/DistributeCustom.vue": [
		"3be5",
		"chunk-01e39a70",
		"chunk-2c846bda",
		"chunk-edc35a34"
	],
	"./Solution/LiveBroadcast.vue": [
		"f62f",
		"chunk-01e39a70",
		"chunk-2c846bda",
		"chunk-aeb4e526"
	],
	"./Solution/Member.vue": [
		"b652",
		"chunk-01e39a70",
		"chunk-2c846bda",
		"chunk-4892b137"
	],
	"./Solution/Micromall.vue": [
		"7ce0",
		"chunk-01e39a70",
		"chunk-2c846bda",
		"chunk-48012962"
	],
	"./Solution/O2OCustom.vue": [
		"d31a",
		"chunk-01e39a70",
		"chunk-2c846bda",
		"chunk-a0b5a654"
	],
	"./Solution/Payment.vue": [
		"a2d2",
		"chunk-01e39a70",
		"chunk-2c846bda",
		"chunk-bd4ec02e"
	],
	"./Solution/Popularize.vue": [
		"45f9",
		"chunk-01e39a70",
		"chunk-2c846bda",
		"chunk-158017e1"
	],
	"./Solution/QcAssociation.vue": [
		"b663d",
		"chunk-01e39a70",
		"chunk-67a112c3",
		"chunk-0b042c3a"
	],
	"./Solution/QcB2BChannel.vue": [
		"e9e8",
		"chunk-01e39a70",
		"chunk-67a112c3",
		"chunk-92ee04fe"
	],
	"./Solution/QcCashier.vue": [
		"26f3",
		"chunk-01e39a70",
		"chunk-67a112c3",
		"chunk-848bbd3c"
	],
	"./Solution/QcChain.vue": [
		"29170",
		"chunk-01e39a70",
		"chunk-67a112c3",
		"chunk-3321b67b"
	],
	"./Solution/QcCommerce.vue": [
		"061f",
		"chunk-01e39a70",
		"chunk-67a112c3",
		"chunk-715922aa"
	],
	"./Solution/QcDigit.vue": [
		"3a2a",
		"chunk-01e39a70",
		"chunk-67a112c3",
		"chunk-643f9bad"
	],
	"./Solution/QcDistribution.vue": [
		"29bd",
		"chunk-01e39a70",
		"chunk-67a112c3",
		"chunk-20ec0dba"
	],
	"./Solution/QcDownload.vue": [
		"f633",
		"chunk-01e39a70",
		"chunk-d1708a88"
	],
	"./Solution/QcErpSystem.vue": [
		"90a8",
		"chunk-01e39a70",
		"chunk-67a112c3",
		"chunk-3f57dbc7"
	],
	"./Solution/QcLiveBroadcast.vue": [
		"375f",
		"chunk-01e39a70",
		"chunk-67a112c3",
		"chunk-baf26f8e"
	],
	"./Solution/QcMarketing.vue": [
		"a845",
		"chunk-01e39a70",
		"chunk-6f863eac"
	],
	"./Solution/QcShopkeeper.vue": [
		"c834",
		"chunk-01e39a70",
		"chunk-fd0cb786"
	],
	"./Solution/QcShoppingMall.vue": [
		"f7e2",
		"chunk-01e39a70",
		"chunk-67a112c3",
		"chunk-0c22a6bb"
	],
	"./Solution/QcTool.vue": [
		"986d",
		"chunk-01e39a70",
		"chunk-72dbefce"
	],
	"./Solution/ShopCustom.vue": [
		"eb68",
		"chunk-01e39a70",
		"chunk-2c846bda",
		"chunk-15d829b8"
	],
	"./Solution/components/IndustrySolution.vue": [
		"3d53",
		"chunk-a1ef51c4"
	],
	"./Solution/copy.vue": [
		"b025",
		"chunk-e1546f10"
	],
	"./Solution/index.vue": [
		"1a56",
		"chunk-01e39a70",
		"chunk-2c846bda",
		"chunk-0bdcddea"
	],
	"./home/index.vue": [
		"f5b8",
		"chunk-01e39a70",
		"chunk-67a112c3",
		"chunk-8b2d5216"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "a2f9";
module.exports = webpackAsyncContext;